import { render, staticRenderFns } from "./BannerLayout.vue?vue&type=template&id=70ed1be4&scoped=true&"
import script from "./BannerLayout.vue?vue&type=script&lang=js&"
export * from "./BannerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed1be4",
  null
  
)

export default component.exports